import React, { useState, useEffect, useContext } from "react";
import { Button, Col, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { excelMapping, ExportToExcel } from "../../utils/utilFuctions";
import { BASE_URL_APISERVICES, BASE_URL_PAYNOW, BASE_URL_REMITTPE } from "../../utils/Constants";
import { offsetArr } from "../../utils/CommonConfig";
import Select from "react-select";
import { GlobalContext } from "../../Context/GlobalState";
import "./MyTable.css";
import swal from "sweetalert";
import axios from "axios";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
export const columns = [
  {
    dataField: "pk_statement_id",
    text: "statement ID",

    color: "#000",
  },
  {
    dataField: "date",
    text: "date",

    color: "#000",
  },
  {
    dataField: "description",
    text: "description",
    color: "#000",
  },
  {
    dataField: "amount",
    text: "amount",

    color: "#000",
  },
  {
    dataField: "amount_indicator",
    text: "amount indicator",

    color: "#000",
  },
  {
    dataField: "balance",
    text: "Balance",

    color: "#000",
  },
  {
    dataField: "balance_indicator",
    text: "balance indicator",
    color: "#000",
  },
  {
    dataField: "narration",
    text: "narration",
    color: "red",
  },
  {
    dataField: "rrn",
    text: "rrn",
    color: "green",
  },

];

const DownloadBankStatement = ({ setDetails }) => {
    const [searchDate, setSearchDate] = useState("");
    const [downloadDate, setDownloadDate] = useState("");
    const [showPanel, setShowPanel] = useState(false);
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");


    const formatDate = (date) => {
        if (!date) return "";
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
    };

    const jsonToCSV = (data) => {
        if (!Array.isArray(data) || data.length === 0) return "";

        const headers = [
            "pk_statement_id",
            "date",
            "description",
            "amount",
            "amount_indicator",
            "balance",
            "balance_indicator",
            "narration",
            "rrn"
        ];

        const csvRows = [
            headers.join(","),
            ...data.map(item =>
                headers.map(key =>
                    `"${String(item[key] ?? "").replace(/"/g, '""')}"`
                ).join(",")
            )
        ];

        return csvRows.join("\n");
    };



    const handleSubmit = async () => {


        if (!searchDate) {
            setErrorMsg("Please select a date first");
            return;
        }

        setLoading(true);

        try {

            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");


            const raw = JSON.stringify({
                    date: searchDate
                } );


            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            }


            const response = await fetch(
                `${BASE_URL_REMITTPE}${API_ENDPOINTS.idfcBankSettlement}`,
                requestOptions
            );

            const result = await response.json();

            setDownloadDate(searchDate);
            setShowPanel(true);

        } catch (error) {
            console.log("Error:", error.response?.data);
        } finally {
            setLoading(false);
        }
    };

    const handleDownload = async () => {
        if (!downloadDate) {
            setErrorMsg("Please select a date to download");
            return;
        }

        setDownloading(true);
        setErrorMsg("");

        try {
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");


            const raw = JSON.stringify({
                    date: downloadDate
                });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            }

            const response = await fetch(
                `${BASE_URL_REMITTPE}${API_ENDPOINTS.idfcBankStatementDownload}`,
                requestOptions
            );

            const result = await response.json();
          const statementData = result.data;

            if (!statementData || statementData.length === 0) {
                setErrorMsg("No data found for selected date");
                return;
            }
         const csvData = jsonToCSV(statementData);

         const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `IDFC_Bank_Statement_${formatDate(downloadDate)}.csv`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            setErrorMsg(
                error.response?.data?.responseMessage ||
                "Something went wrong while downloading"
            );
            console.log("CSV Download Error:", error.response?.data);
        } finally {
            setDownloading(false);
        }
    };
  return (
    <div className="py-2 " style={{ backgroundColor: "rgb(238, 238, 238)" }}>
      <div className="card m-0 p-0">
            <div className="container-xl my-5" style={{ maxWidth: '1140px', fontFamily: 'sans-serif' }}>
           
           <style>
               {`
                   .rounded-xl { border-radius: 0.75rem !important; }
                   .rounded-2xl { border-radius: 1rem !important; }
                   .bg-gray-50 { background-color: #f8f9fa !important; }
                   .btn-blue { background-color: #1e40af !important; border-color: #1e40af !important; color: white !important; }
                   .btn-blue:hover { background-color: #1d4ed8 !important; }
                   .text-idfc { color: #1e40af !important; }
                  
                   @keyframes fadeInDown {
                       from { opacity: 0; transform: translateY(-20px); }
                       to { opacity: 1; transform: translateY(0); }
                   }
                   .animate-fade-in {
                       animation: fadeInDown 0.4s ease-out forwards;
                   }
               `}
           </style>

           <div className="container-xl my-5">
              
               <div className="pb-4">
                   <h1 className="h3 text-center text-uppercase fw-bold text-idfc">
                       IDFC Bank Statement
                   </h1>
               </div>

              
               <div className="bg-white border rounded-2xl p-4 d-flex flex-column flex-md-row gap-3 align-items-md-end shadow-sm">
                   <div className="flex-grow-1">
                       <label className="form-label small fw-bold text-secondary mb-2">
                           Select Date
                       </label>
                       <input
                           type="date"
                           className="form-control form-control-lg rounded-xl bg-gray-50 border-secondary-subtle shadow-none"
                           value={searchDate}
                           onChange={(e) => setSearchDate(e.target.value)}
                       />
                   </div>

                   <button
                       onClick={handleSubmit}
                       disabled={loading}
                       className="btn btn-blue px-4 py-3 rounded-xl fw-bold d-flex justify-content-center align-items-center transition-all"
                       style={{ minWidth: '160px', height: '54px' , marginLeft:"1rem" }}
                   >
                       {loading ? (
                           <span className="d-flex align-items-center gap-2">
                               <div className="spinner-border spinner-border-sm" role="status"></div>
                               Processing...
                           </span>
                       ) : "Submit"}
                   </button>
               </div>

              
               {errorMsg && (
                   <div className="alert alert-danger mt-4 rounded-xl border-danger-subtle small py-3 animate-fade-in" role="alert">
                       {errorMsg}
                   </div>
               )}

              
               {showPanel && (
                   <div className="mt-4 bg-white border rounded-2xl p-4 d-flex flex-column flex-md-row justify-content-between align-items-md-end gap-3 shadow-sm animate-fade-in">
                       <div className="flex-grow-1">
                           <label className="form-label small fw-bold text-secondary mb-2">
                               Select Download Date
                           </label>
                           <input
                               type="date"
                               className="form-control form-control-lg rounded-xl bg-gray-50 border-secondary-subtle shadow-none"
                               value={downloadDate}
                               onChange={(e) => setDownloadDate(e.target.value)}
                           />
                       </div>

                       <button
                           disabled={downloading}
                           onClick={handleDownload}
                           className={`btn px-4 py-3 rounded-xl fw-bold d-flex justify-content-center align-items-center gap-2 shadow-sm ${downloading ? "btn-secondary disabled" : "btn-success"
                               }`}
                           style={{ minWidth: '200px', height: '54px' }}
                       >
                           {downloading ? (
                               <>
                                   <div className="spinner-border spinner-border-sm" role="status"></div>
                                   <span>Downloading...</span>
                               </>
                           ) : "Download file"}
                       </button>
                   </div>
               )}
           </div>
       </div>
      
      </div>
    </div>
  );
};


export default DownloadBankStatement;